import React from "react";
import AuthLayout from "../../components/auth/AuthLayout";
import PageTitle from "../../components/auth/PageTitle";
import ClubInfoSteps from "../../components/auth/ClubInfoSteps";
import ClubInfoForm1 from "../../components/auth/ClubInfoForm1";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";

const ClubInfo1 = () => {
  const { Auth }: DictionaryType = useGetDictionary();
  return (
    <AuthLayout>
      <div className="  flex flex-col gap-8 px-12">
        <div className="flex flex-col gap-5 text-center">
          <PageTitle title={Auth?.club_info_1.club_info_title} />
          <p className="text-lg font-normal leading-[22.68px] text-[#1E1850] mt-2">
            {Auth?.club_info_1.club_info_subtitle}
          </p>
        </div>
        <ClubInfoSteps
          servicesActive={false}
          courtsActive={false}
          hoursBold={true}
          servicesBold={false}
          courtsBold={false}
        />
        <ClubInfoForm1 />
      </div>
    </AuthLayout>
  );
};

export default ClubInfo1;
